import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';

import { Alert, FormElems } from 'components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { pgCredentialsOnboardingFormValidator } from './validator';
import { useHistory } from 'react-router-dom';
import { showLoader, hideLoader } from 'redux/common/loader/loader.actions';
import { compose } from 'redux';
import {
    PAYMENT_GATEWAY_CREDENTIALS_FIELD_MAP,
    PAYMENT_GATEWAY_OPTION,
} from '../constants';
import { toast } from 'react-toastify';
import {
    createPaymentGatewayCredentialStepRequest,
    resetPaymentGatewayCredentialCreateFormData,
    resetPaymentGatewayCredentialUpdateFormData,
    updatePaymentGatewayCredentialStepRequest,
    fetchPaymentGatewayCredentialDataRequest
} from '../redux/paymentGatewayCredentials.actions';

const ShowPgCode = (isViewMode) => {
    let fieldData = {
        name: 'merchantPGCode',
        label: 'Merchant PG Code',
        placeholder: 'Enter PG Code',
    }
    return (
    <>
        <div className="form-field">
            <p className="label">{fieldData.label}</p>
            <Field
                name={`credentials.${fieldData.name}`}
                id={`${fieldData.name}`}
                placeholder = {fieldData?.placeholder || ''}
                type = 'text'
                component={FormElems.Input}
                disabled={isViewMode}
            />
        </div>
    </>
)
}

const PGCredentialsForm = ({
    handleSubmit,
    staticData,
    isEditMode,
    formData,
    isViewMode,
    actions,
    paymentGatewayCredentialsData,
    nextPath,
    sectionType,
    initialValues,
    formIdentifier,
}) => {
    const history = useHistory();

    const { staticInfo } = staticData;
    const { createFormData, editFormData } = paymentGatewayCredentialsData;

    // const isLoading = createFormData.isLoading || editFormData.isLoading || paymentGatewayCredentialsData.isLoading;
    // console.log("loding", isLoading);

    const errorMessage =
        createFormData &&
        createFormData.error &&
        createFormData.error.errorMessage;

    const [categoryCodeList, setCategoryCodeList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState({});
    const [subCategoryList, setSubCategoryList] = useState([]);

    useEffect(() => {
        console.log("okokookkkkk inside pricing form", isViewMode, "seperator", isEditMode);
        if(isEditMode || isViewMode){
            actions.showLoader();
            actions.fetchPaymentGatewayCredentialDataRequest({
                pgMidReferenceId: parseInt(formIdentifier),
            });
        }
    }, []);

    useEffect(() => {
        // Listen for changes in paymentGatewayCredentialsData to hide loader on success
        if(isEditMode || isViewMode){
            actions.showLoader();
        }
        if (editFormData.isSuccess) {
            actions.hideLoader(); // Hide loader on successful data fetch
        }
    }, [editFormData.isSuccess]);

    useEffect(() => {
        if (initialValues.category && staticInfo && staticInfo.categoryMap) {
            const category = staticInfo.categoryMap.find(
                item =>
                    item.name.toLowerCase() ===
                    initialValues.category.toLowerCase()
            );

            // set the selected category
            setSelectedCategory(category || {});

            // Get subCategory options based on selected category
            const subCategoryOptions =
                category &&
                category.options.map(item => {
                    return { name: item?.subCategory, value: item?.subCategory };
                });
            
            setSubCategoryList(subCategoryOptions || []);

            if(initialValues?.sub_category_name){
                // Set the initial subCategory value if it exists
                initialValues.subCategory = initialValues?.sub_category_name;

                // Find the subCategory based on the initial value
                const subCategory = category?.options.find(
                    item => 
                        item?.subCategory?.toLowerCase() ===
                        initialValues?.subCategory?.toLowerCase()
                );
    
                // set respective mcc options
                const mccOptions = subCategory && subCategory.mcc.map(code => ({ name: code, value: code }));
                setCategoryCodeList(mccOptions || []);
            }
        }
    }, [initialValues, staticInfo]);

    useEffect(() => {
        if (
            createFormData.isSuccess &&
            createFormData.sectionType === sectionType
        ) {
            toast.success('PG Credential request created successfully');
            onNext();
        }
        return () => {
            if (
                createFormData.isSuccess &&
                createFormData.sectionType === sectionType
            ) {
                actions.resetPaymentGatewayCredentialCreateFormData();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createFormData.isSuccess, createFormData.sectionType]);

    useEffect(() => {
        if (
            editFormData.isSuccess &&
            editFormData.sectionType === sectionType
        ) {
            if(!isViewMode){
                toast.success('PG Credential request updated successfully ');
            }
            onNext();
        }
        return () => {
            if (
                editFormData.isSuccess &&
                editFormData.sectionType === sectionType
            ) {
                actions.resetPaymentGatewayCredentialUpdateFormData();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editFormData.isSuccess, editFormData.sectionType]);

    const resetErrors = () => {
        actions.resetPaymentGatewayCredentialCreateFormData();
    };

    const onNext = () => {
        console.log("inside onNext fun, credentials", isEditMode, isViewMode);
        if(!isEditMode){
            resetErrors();
        }
        history.push(nextPath);
    };

    const onBack = () => {
        history.push('/payment-gateway-credentials');
    };

    const handleFormSubmit = values => {
        const request = {
            ...values,
        };
        if (isViewMode) {
            onNext();
        } else if (formIdentifier) {
            request.referenceId = formIdentifier;
            values.actionType = 'create';
            actions.updatePaymentGatewayCredentialStepRequest(
                request,
                sectionType,
                values
            );
        } 
        else if (isEditMode) {
            request.referenceId = formIdentifier;
            actions.updatePaymentGatewayCredentialStepRequest(
                request,
                sectionType
            );
        } else {
            actions.createPaymentGatewayCredentialStepRequest(
                request,
                sectionType,
                values
            );
        }
    };

    // Handle subCategory selection and reset mcc options
    const handleSubCategorySelect = value => {
        try {
            // Reset mcc when subCategory changes
            if (selectedCategory && selectedCategory.options && value) {
                const subCategory = selectedCategory.options.find(
                    item => item.subCategory.toLowerCase() === value.toLowerCase()
                );
                
                // Reset mcc when subCategory changes
                const mccOptions = subCategory && subCategory.mcc.map(code => ({ name: code, value: code }));
                setCategoryCodeList(mccOptions || []);
                
                // If form is in edit mode, set MCC value based on selected category
                if (isEditMode && formData && formData.values) {
                    const mccValue = formData.values.mcc;
                    if (!mccValue) {
                        actions.change(
                            'pg-credentials-onboarding-form',
                            'mcc',
                            mccOptions[0]?.value || ''
                        );
                    }
                }
            }
        } catch (error) {
            console.error('Error in handleSubCategorySelect:', error);
        }
    };

    // Handle category selection and set subCategory and mcc options
    const handleCategorySelect = value => {
        try {
            // Reset subCategory and mcc when category changes
            if (staticInfo && staticInfo.categoryMap && value) {
                const category = staticInfo.categoryMap.find(
                    item => item.name.toLowerCase() === value.toLowerCase()
                );
                setSelectedCategory(category || {});

                // Get subCategory options based on selected category
                const subCategoryOptions =
                    category &&
                    category.options.map(item => {
                        return { name: item?.subCategory, value: item?.subCategory };
                    });
                setSubCategoryList(subCategoryOptions || []);
                setCategoryCodeList([]);
            }
        } catch (error) {
            console.error('Error in handleCategorySelect:', error);
        }
    };

    return (
        <form
            className="pg-onboarding-form card"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <h2 className="tab-title">Credential Details</h2>
            <ul className="form-list">
                <li className="form-section">
                    <div className="form-field">
                        <p className="label">Payment Gateway</p>
                        <Field
                            name="pgName"
                            data={PAYMENT_GATEWAY_OPTION}
                            label="Select Payment Gateway"
                            labelField="name"
                            valueField="value"
                            component={FormElems.Select}
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">PG Category</p>
                        <Field
                            name="category"
                            id="pg-category"
                            data={staticInfo.categoryMap || []}
                            labelField="name"
                            valueField="value"
                            component={FormElems.Select}
                            label="Enter Category"
                            placeholder="Enter Category"
                            onChange={value => {
                                handleCategorySelect(value);
                                actions.change(
                                    'pg-credentials-onboarding-form',
                                    'subCategory',
                                    ''
                                );
                                actions.change(
                                    'pg-credentials-onboarding-form',
                                    'mcc',
                                    ''
                                );
                            }}
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Sub Category</p>
                        <Field
                            name="subCategory"
                            id="sub-category"
                            data={subCategoryList || []}
                            labelField="name"
                            valueField="value"
                            component={FormElems.Select}
                            label="Enter Sub Category"
                            placeholder="Enter Sub Category"
                            disabled={isViewMode}
                            onChange={value => {
                                handleSubCategorySelect(value);
                                actions.change(
                                    'pg-credentials-onboarding-form',
                                    'mcc',
                                    ''
                                );
                            }}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Merchant Category Code</p>
                        <Field
                            name="mcc"
                            id="mcc"
                            data={categoryCodeList || []}
                            labelField="name"
                            valueField="value"
                            component={FormElems.Select}
                            label="Enter Code"
                            placeholder="Enter Code"
                            disabled={isViewMode}
                        />
                    </div>
                </li>
            </ul>
            {formData && formData.values && formData.values.pgName ? (
                <>
                    <div className="border-b"></div>
                    <ul className="form-list">
                        <li className="form-section">
                        {ShowPgCode(isViewMode)}
                        {PAYMENT_GATEWAY_CREDENTIALS_FIELD_MAP[
                            formData.values.pgName
                        ].map((field, index) => {
                            return (
                                <div className="form-field">
                                    <p className="label">{field.label}</p>
                                    <FormField
                                        field={field}
                                        isViewMode={isViewMode}
                                        index={index}
                                    />
                                </div>
                            );
                        })}
                        </li>
                    </ul>
                </>
            ) : (
                <></>
            )}
            {errorMessage ? (
                <Alert customClass="error-msg">{errorMessage}</Alert>
            ) : null}
            <div className="form-section action">
                <FormElems.Button
                    id="back-btn"
                    buttonType="secondary"
                    text="Close"
                    type="button"
                    handleClick={onBack}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="Next"
                />
            </div>
        </form>
    );
};

const FormField = props => {
    const { field, isViewMode, item, index } = props;
    const fieldName = `credentials.${field.name}`;
    if (field.fieldType === 'select') {
        return (
            <Field
                name={fieldName}
                id={`${field.name}`}
                {...field.props}
                component={FormElems.Select}
                disabled={isViewMode}
            />
        );
    } else if (field.fieldType === 'radio') {
        return (
            <Field
                name={`${item}.${field.name}`}
                id={`${field.name}`}
                {...field.props}
                component={FormElems.Radio}
                disabled={isViewMode}
            />
        );
    } else if (field.fieldType === 'checkbox') {
        return (
            <Field
                name={`${item}.${field.name}`}
                id={`${field.name}`}
                {...field.props}
                component={FormElems.Checkbox}
                disabled={isViewMode}
            />
        );
    } else if (field.fieldType === 'switch') {
        return (
            <Field
                name={`${item}.${field.name}`}
                id={`${field.name}`}
                {...field.props}
                component={FormElems.Switch}
                isDisabled={isViewMode}
            />
        );
    } 
    console.log(".....merchant pg code", field);
    if (field.name === 'merchantPGCode') {
        return (<Field
            name={fieldName}
            id={`${field.name}`}
            placeholder = {field?.props?.placeholder || ''}
            type = 'text'
            component={FormElems.Input}
            disabled={isViewMode}
        />);
    }
    return (
        <Field
            name={fieldName}
            id={`${field.name}`}
            {...field.props}
            component={FormElems.Input}
            disabled={isViewMode}
        />
    );
};
FormField.propTypes = {
    field: PropTypes.object,
    testPrefix: PropTypes.string,
    isViewMode: PropTypes.bool,
    item: PropTypes.string,
    fields: PropTypes.array,
    index: PropTypes.number,
    customFieldOptions: PropTypes.object,
};

const mapStateToProps = ({
    auth,
    form,
    staticData,
    paymentGatewayCredentialsData,
}) => ({
    auth,
    formData: form['pg-credentials-onboarding-form'],
    staticData,
    paymentGatewayCredentialsData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            change,
            showLoader,
            hideLoader,
            createPaymentGatewayCredentialStepRequest,
            resetPaymentGatewayCredentialCreateFormData,
            updatePaymentGatewayCredentialStepRequest,
            resetPaymentGatewayCredentialUpdateFormData,
            fetchPaymentGatewayCredentialDataRequest
        },
        dispatch
    ),
});

PGCredentialsForm.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    staticData: PropTypes.object,
    handleSubmit: PropTypes.func,
    formData: PropTypes.object,
    change: PropTypes.func,
    paymentGatewayCredentialsData: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'pg-credentials-onboarding-form',
        validate: pgCredentialsOnboardingFormValidator,
        enableReinitialize: true,
        // destroyOnUnmount:true
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(PGCredentialsForm);
